import {Icon} from 'antd';

class Layout extends Component {
    constructor(props){
        super(props);
    }

    render(){
        return (
            <>
                <Icon type="github" />
                    {this.props.children}
                <footer>This is footer</footer>
            </>
        );
    }
}

export {Layout};